import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITooltipContent from 'UIComponents/tooltip/UITooltipContent';
import HR from 'UIComponents/elements/HR';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { BREACHED, IN_SLA, RESOLVED_IN_SLA, RESOLVED_OUT_OF_SLA, SLA_WARNING } from 'conversations-thread-data/tickets/public/constants';
import SLADetailRow from './SLADetailRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLATooltipHeader = ({
  activeSLAStatus
}) => {
  switch (activeSLAStatus) {
    case IN_SLA:
    case RESOLVED_IN_SLA:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.statusHeaders.inSLA"
      });
    case BREACHED:
    case RESOLVED_OUT_OF_SLA:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.statusHeaders.breached"
      });
    case SLA_WARNING:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.statusHeaders.warning"
      });
    default:
      throw new Error('SLA status is not in SLAStatusEnum');
  }
};
SLATooltipHeader.displayName = 'SLATooltipHeader';
const SLADetailsTooltip = ({
  children,
  slas,
  activeSLA
}) => {
  const SLATooltipContent = () => /*#__PURE__*/_jsxs(UITooltipContent, {
    children: [/*#__PURE__*/_jsx(SLATooltipHeader, {
      activeSLAStatus: activeSLA.status
    }), /*#__PURE__*/_jsx(HR, {
      distance: "xs"
    }), Object.values(slas).map(sla => /*#__PURE__*/_jsx(SLADetailRow, {
      slaDetails: sla
    }, sla.category))]
  });
  SLATooltipContent.displayName = 'SLATooltipContent';
  return /*#__PURE__*/_jsx(UITooltip, {
    use: "longform",
    placement: "bottom",
    Content: SLATooltipContent,
    maxWidth: 600,
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  });
};
SLADetailsTooltip.displayName = 'SLADetailsTooltip';
export default SLADetailsTooltip;